import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * パスワード再設定用クラス
 */
@JsonObject('PasswordResetSettingParam')
export default class PasswordResetSettingParam {
  constructor() {
    this.token = undefined;
    this.birthYear = undefined;
    this.birthMonth = undefined;
    this.birthDate = undefined;
    this.newPassword = undefined;
    this.newPasswordConfirmation = undefined;
  }

  @JsonProperty('token')
  public token?: string;

  @JsonProperty('birth_year')
  public birthYear?: string;

  @JsonProperty('birth_month')
  public birthMonth?: string;

  @JsonProperty('birth_date')
  public birthDate?: string;

  @JsonProperty('new_password')
  public newPassword?: string;

  @JsonProperty('new_password_confirmation')
  public newPasswordConfirmation?: string;
}
